import React, { PropsWithChildren } from "react";
import { Control, Controller, FieldPath, FieldPathValue, FieldValues } from "react-hook-form";
import { useSearchAutocomplete } from "Hooks";
import resolvePath from "Utils/resolvePath";
import { Autocomplete, BaseAutocompleteProps } from "./Autocomplete";
import { GeoSearchAutocomplete } from "Services/API/API";
import { KnownSearchAutocomplete } from "Models/Search";

interface AddressAutocompleteControlledProps<T extends FieldValues> extends BaseAutocompleteProps {
   control: Control<T>;
   name: FieldPath<T>;

}
export const AddressAutocompleteControlled = function <T extends FieldValues>({ control, name, ...baseProps }: PropsWithChildren<AddressAutocompleteControlledProps<T>>) {
   const withUseAutocompleteOptions = useSearchAutocomplete();

   return (
      <Controller control={control} name={name} render={({ field, formState: { errors } }) => {
         const error = resolvePath(errors, name);
         return <Autocomplete<KnownSearchAutocomplete>
            value={field.value}
            onChange={value => field.onChange(value as FieldPathValue<T, typeof name>)}
            itemToString={(item) => item instanceof GeoSearchAutocomplete ? item.geoQuery : ""}
            isInvalid={!!error}
            validationMessage={error?.message}
            filterOptions={(option) => option instanceof GeoSearchAutocomplete}
            {...baseProps}
            {...withUseAutocompleteOptions}
         />
      }} 
      />
   );
}